//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconFormTextAlignLeft(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M5 5H19V7H5V5ZM5 9H13.75V11H5V9ZM13.75 17H5V19H13.75V17ZM5 13H19V15H5V13Z" fill="currentColor" /></svg>;
}
export default IconFormTextAlignLeft;